import { createFileRoute } from '@tanstack/react-router';
import { ProviderCredentialsSettings } from '@/components/providers/provider-credentials-settings';

export const Route = createFileRoute('/_auth/_side-layout/super-admin/crm')({
  component: () => (
    <ProviderCredentialsSettings
      capabilities={['crm', 'notification']}
      title="Integration Apps"
      description="The OAuth apps customers install when they connect a CRM or Slack from Integrations. Stored encrypted per environment; secrets are write-only."
    />
  ),
});
